import { useState, useEffect, useRef } from "react";
import { Link as ScrollLink, Element, Events, scrollSpy } from "react-scroll";

import { Footer } from "./footer";
import "../styles/global.css";
import "../styles/global-medium.css";
import "../styles/global-large.css";
import "../styles/index.css";

export default function Index() {
  const [video1Play, setVideo1Play] = useState(false);
  const [video2Play, setVideo2Play] = useState(false);
  const [video3Play, setVideo3Play] = useState(false);
  const [video4Play, setVideo4Play] = useState(false);
  const [video1Ended, setVideo1Ended] = useState(false);
  const [video2Ended, setVideo2Ended] = useState(false);
  const [video3Ended, setVideo3Ended] = useState(false);
  const [video4Ended, setVideo4Ended] = useState(false);
  const video1Ref = useRef(null);
  const video2Ref = useRef(null);
  const video3Ref = useRef(null);
  const video4Ref = useRef(null);

  useEffect(() => {
    Events.scrollEvent.register("begin", function (to, element) {});
    Events.scrollEvent.register("end", function (to, element) {});
    scrollSpy.update();
    return () => {
      Events.scrollEvent.remove("begin");
      Events.scrollEvent.remove("end");
    };
  }, []);

  const togglePlayOrPause = (videoNumber) => {
    switch (videoNumber) {
      case 1:
        setVideo1Ended(false);
        setVideo1Play((prev) => {
          if (!video1Ref?.current) throw new Error();
          if (prev) {
            video1Ref.current.pause();
          } else {
            video1Ref.current.play();
          }
          return !prev;
        });

        break;
      case 2:
        setVideo2Ended(false);
        setVideo2Play((prev) => {
          if (!video2Ref?.current) throw new Error();
          if (prev) {
            video2Ref.current.pause();
          } else {
            video2Ref.current.play();
          }
          return !prev;
        });

        break;
      case 3:
        setVideo3Ended(false);
        setVideo3Play((prev) => {
          if (!video3Ref?.current) throw new Error();
          if (prev) {
            video3Ref.current.pause();
          } else {
            video3Ref.current.play();
          }
          return !prev;
        });

        break;
      case 4:
        setVideo4Ended(false);
        setVideo4Play((prev) => {
          if (!video4Ref?.current) throw new Error();
          if (prev) {
            video4Ref.current.pause();
          } else {
            video4Ref.current.play();
          }
          return !prev;
        });

        break;
    }
  };

  const setVideoEnded = (videoNumber) => {
    switch (videoNumber) {
      case 1:
        setVideo1Play(false);
        setVideo1Ended(true);
        break;

      case 2:
        setVideo2Play(false);
        setVideo2Ended(true);
        break;

      case 3:
        setVideo3Play(false);
        setVideo3Ended(true);
        break;

      case 4:
        setVideo4Play(false);
        setVideo4Ended(true);
        break;
    }
  };

  return (
    <div>
      <div className="container">
        <div className="hero-container">
          <div className="hero-title-container">
            <h1>Travel planning, simplified.</h1>
          </div>
          <p>
            Traveling is amazing, but planning what to do and when to do it can
            be a nightmare. Not anymore. Trava takes the work out of travel—for
            free.
          </p>
          <div className="see-more">
            <ScrollLink
              to="step-1"
              activeClass="active"
              spy={true}
              smooth={true}
              duration={500}
            >
              <div className="how-it-works-container">
                <p>How it works</p>
                <img
                  src="/images/DOWN-CHEVRON.svg"
                  width={20}
                  height={13}
                  alt="See more icon"
                  className="margin-top"
                />
              </div>
            </ScrollLink>
          </div>
        </div>
        <Element name="step-1" className="element"></Element>
        <section className="section-container">
          <div className="section-text-container">
            <p className="blue-text">Step 1</p>
            <h2 className="section-title">Create your trip</h2>
            <p>
              Choose a destination, invite friends and family, and get ready for
              the smoothest trip planning of your life.
            </p>
          </div>
          <div className="image-container">
            <div
              className="video-container"
              onClick={() => togglePlayOrPause(1)}
            >
              <img
                src="/images/step1-poster-compressed.jpg"
                alt="Choose a destination and create your trip"
                className="load-image"
              />
              <div className="video-border">
                <div className="notch"></div>
              </div>
              <video
                src="https://trava.mo.cloudinary.net/hq/step1-hq.mp4"
                muted
                playsInline
                preload="metadata"
                poster="/images/step1-poster-compressed.jpg"
                ref={video1Ref}
                onEnded={() => setVideoEnded(1)}
                height={700}
                width={324}
              ></video>
              {!video1Play ? (
                <div className="overlay">
                  <div className="gradient-overlay"></div>
                  <p className="play-btn">{video1Ended ? "↻" : "▶"}</p>
                </div>
              ) : null}
            </div>
          </div>
        </section>
        <section className="section-container">
          <div className="section-text-container right-text-container">
            <p className="green-text">Step 2</p>
            <h2 className="section-title">Vote for your favorite activities</h2>
            <p>
              View our{" "}
              <span className="bold-text green-text">
                Expert-Curated Recommendations
              </span>{" "}
              for things to do and places to eat, or add your own hidden gems.
              <br></br>
              <br></br>
              Swipe on what sounds fun; everybody else in your group will do the
              same.
            </p>
          </div>
          <div className="image-container">
            <div
              className="video-container left-image-container"
              onClick={() => togglePlayOrPause(2)}
            >
              <img
                src="/images/step2-poster-compressed.jpg"
                alt="Swipe your way to an itinerary"
                className="load-image"
              />
              <div className="video-border">
                <div className="notch"></div>
              </div>
              <video
                src="https://trava.mo.cloudinary.net/hq/step2-hq.mp4"
                muted
                playsInline
                preload="metadata"
                poster="/images/step2-poster-compressed.jpg"
                ref={video2Ref}
                onEnded={() => setVideoEnded(2)}
                height={700}
                width={324}
              ></video>
              {!video2Play ? (
                <div className="overlay">
                  <div className="gradient-overlay"></div>
                  <p className="play-btn">{video2Ended ? "↻" : "▶"}</p>
                </div>
              ) : null}
            </div>
          </div>
        </section>
        <section className="section-container">
          <div className="section-text-container">
            <p className="yellow-text">Step 3</p>
            <h2 className="section-title">
              Please everyone with Smart Itineraries
            </h2>
            <p>
              Our{" "}
              <span className="bold-text yellow-text">
                Smart-Scheduling Algorithm
              </span>{" "}
              recognizes your group’s favorite activities and schedules them in
              a logistically-optimized manner.
            </p>

            <div className="bullets">
              <br></br>
              <p>✓ No more hassle</p>
              <p>✓ No more arguing</p>
              <p>✓ No more agonizing over logistics</p>
            </div>
          </div>
          <div className="image-container">
            <div
              className="video-container"
              onClick={() => togglePlayOrPause(3)}
            >
              <img
                src="/images/step3-poster-compressed.jpg"
                alt="Our algorithm determines your group's favorite activities"
                className="load-image"
              />
              <div className="video-border">
                <div className="notch"></div>
              </div>
              <video
                src="https://trava.mo.cloudinary.net/hq/step3-hq.mp4"
                muted
                playsInline
                preload="metadata"
                poster="/images/step3-poster-compressed.jpg"
                ref={video3Ref}
                onEnded={() => setVideoEnded(3)}
                height={700}
                width={324}
              ></video>
              {!video3Play ? (
                <div className="overlay">
                  <div className="gradient-overlay"></div>
                  <p className="play-btn">{video3Ended ? "↻" : "▶"}</p>
                </div>
              ) : null}
            </div>
          </div>
        </section>
      </div>
      <section className="section-container">
        <div className="social-black-bg"></div>
        <div className="social-container-content container">
          <div className="section-text-container right-text-container">
            <p className="red-text">Celebrate and Inspire</p>
            <h2 className="section-title social-text condensed-social-title">
              Share with the Community
            </h2>
            <h2 className="section-title social-text expanded-social-title">
              Come for an itinerary, stay for the Community
            </h2>
            <p className="social-text">
              Trava empowers you to share more than just memories. With{" "}
              <span className="bold-text red-text">Activity Tagging</span>, just
              one tap saves an activity for your next trip.
            </p>
            <div>
              <br></br>
              <p className="social-text">✓ Inspire and be inspired</p>
              <p className="social-text">
                ✓ Discover new vacation destinations
              </p>
              <p className="social-text">✓ Build your bucket list</p>
            </div>
          </div>
          <div className="image-container">
            <div
              className="video-container left-image-container"
              onClick={() => togglePlayOrPause(4)}
            >
              <div className="video4container"></div>
              <img
                src="/images/step4-poster-compressed.jpg"
                alt="View others' posts for inspiration"
                className="load-image"
              />
              <div className="video-border video-border-social">
                <div className="notch notch-social"></div>
              </div>
              <video
                src="https://trava.mo.cloudinary.net/hq/step4-hq.mp4"
                muted
                playsInline
                preload="metadata"
                poster="/images/step4-poster-compressed.jpg"
                ref={video4Ref}
                onEnded={() => setVideoEnded(4)}
                height={700}
                width={324}
              ></video>
              {!video4Play ? (
                <div className="overlay">
                  <div className="gradient-overlay"></div>
                  <p className="play-btn">{video4Ended ? "↻" : "▶"}</p>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
      <div className="container">
        <section className="section-more">
          <h2 className="section-title">And much more...</h2>
          <p>
            Ready to plan your vacation or just looking for some inspiration?
            <br></br>
            Join us as we reinvent travel planning.
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
}
